import axios from 'axios';
import { UPDATE_WELL_STATUS_API_URL, UPDATE_PILLAR_STATUS_API_URL, UPDATE_COUPLING_STATUS_API_URL, UPDATE_FOB_STATUS_API_URL,
   UPDATE_CABLE_STATUS_API_URL, UPDATE_CABLE_STATUS_ACTIVITY_API_URL, UPDATE_PON_BOX_STATUS_API_URL, 
   UPDATE_CABLE_FEATURE_PON_API_URL,
   UPDATE_CABLE_FEATURE_KTV_API_URL,
   UPDATE_CABLE_FEATURE_ETHER_API_URL,
   UPDATE_FOB_FEATURE_PON_API_URL,
   UPDATE_FOB_FEATURE_KTV_API_URL,
   UPDATE_FOB_FEATURE_ETHER_API_URL,
   UPDATE_COUPLING_FEATURE_PON_API_URL,
   UPDATE_COUPLING_FEATURE_KTV_API_URL,
   UPDATE_COUPLING_FEATURE_ETHER_API_URL,
   UPDATE_PONBOX_FEATURE_PON_API_URL,
   UPDATE_PONBOX_FEATURE_KTV_API_URL,
   UPDATE_PONBOX_FEATURE_ETHER_API_URL,
   UPDATE_DIVIDER_FEATURE_PON_API_URL,
   UPDATE_DIVIDER_FEATURE_KTV_API_URL,
   UPDATE_PASSIVE_NODE_STATUS_API_URL,
   UPDATE_AMPLIFIER_STATUS_ACTIVITY_API_URL} from '../OpticApiConfig';
import { CABLE, WELL, PILLAR, COUPLING, FOB, PON_BOX, PASSIVE_NODE } from '../Constants/ConstantsOptics';   

// Обновление статуса компонента (отображение / скрытие) NEW
export const UpdateStatusComponents = async (selectedComponent, inputId, showSnackbar, user, refresh, close, cantonCablaByIdRefresh ) => {

  const token = localStorage.getItem('token');
  if(selectedComponent === '' || inputId === '') {
    showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
  }  
  else if (!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

    if (selectedComponent === WELL) {
      try {
        const response = await axios.patch(`${UPDATE_WELL_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Колодец удален!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Колодец с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    }else if (selectedComponent === PILLAR) {
      try {
        const response = await axios.patch(`${UPDATE_PILLAR_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Опора удалена!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Опора с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } else if (selectedComponent === COUPLING) {
      try {
        const response = await axios.patch(`${UPDATE_COUPLING_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Муфта удалена!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Муфта с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    }  else if (selectedComponent === FOB) {
      try {
        const response = await axios.patch(`${UPDATE_FOB_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Фоб удалена!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Фоб с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } else if (selectedComponent === CABLE) {
      try {
        const response = await axios.patch(`${UPDATE_CABLE_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Кабель удалена!', 'snackbarWarning');
              //refresh();
              cantonCablaByIdRefresh(inputId);
              close();
          } else if (response.status === 404) {
              showSnackbar('Кабель с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } 

    else if (selectedComponent === PON_BOX) {
      try {
        const response = await axios.patch(`${UPDATE_PON_BOX_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Пон-бокс удален!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Пон-бокс с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } 

     else if (selectedComponent === PASSIVE_NODE) {
      try {
        const response = await axios.patch(`${UPDATE_PASSIVE_NODE_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
             // showSnackbar('Узел удален!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Узел с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } 
    
    else {
      showSnackbar('Какая-то очень страшная ошибка!', 'snackbarWarning');
    }
  }
}

// Обновление статуса компонента (отображение / скрытие) NEW
export const UpdateStatusComponentsHighway = async (selectedComponent, inputId, showSnackbar, user, refresh, close ) => {

  const token = localStorage.getItem('token');
  if(selectedComponent === '' || inputId === '') {
    showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
  }  
  else if (!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_FOB_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Фоб удалена!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Фоб с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    if (selectedComponent === CABLE) {
      try {
        const response = await axios.patch(`${UPDATE_CABLE_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Кабель удалена!', 'snackbarWarning');
              refresh();
              close();
          } else if (response.status === 404) {
              showSnackbar('Кабель с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    } 
    
    else {
      showSnackbar('Какая-то очень страшная ошибка!', 'snackbarWarning');
    }
  }
}

// // Обновление статуса компонента (отображение / скрытие) с модального окна "ПОИСК"
export const UpdateStatusComponentsModalSearch = async (selectedComponent, inputId, showSnackbar, user, setSelectedComponent, setInputId, resetAllState) => {
    const token = localStorage.getItem('token');
    if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    }  
    else if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }else {

      if (selectedComponent === WELL) {
        try {
          const response = await axios.patch(`${UPDATE_WELL_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Колодец удален!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Колодец с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      }else if (selectedComponent === PILLAR) {
        try {
          const response = await axios.patch(`${UPDATE_PILLAR_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Опора удалена!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Опора с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      } else if (selectedComponent === COUPLING) {
        try {
          const response = await axios.patch(`${UPDATE_COUPLING_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Муфта удалена!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Муфта с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      }  else if (selectedComponent === FOB) {
        try {
          const response = await axios.patch(`${UPDATE_FOB_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Фоб удалена!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Фоб с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      } else if (selectedComponent === CABLE) {
        try {
          const response = await axios.patch(`${UPDATE_CABLE_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Кабель удалена!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Кабель с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      } 

      else if (selectedComponent === PON_BOX) {
        try {
          const response = await axios.patch(`${UPDATE_PON_BOX_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
          });

            if (response.status === 200) {
                showSnackbar('Пон-бокс удален!', 'snackbarWarning');
                resetAllState();
            } else if (response.status === 404) {
                showSnackbar('Пон-бокс с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
            } else {
                showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
            }
            setSelectedComponent('');
            setInputId('');
        } catch (error) {
          showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
        }
      } 
      
      else {
        showSnackbar('Какая-то очень страшная ошибка!', 'snackbarWarning');
      }
    }
  }

  // Обновление Optic Activity
export const UpdateLineActivityComponents = async (lineId, status, showSnackbar, handleClickSummit, user, cantonCablaByIdRefresh) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_CABLE_STATUS_ACTIVITY_API_URL}${lineId}`,{ activity: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Статус изменен!', 'snackbarWarning');
              cantonCablaByIdRefresh(lineId);
              //handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Optic PON
export const UpdateLinePonComponents = async (lineId, status, showSnackbar, handleClickSummit, user, cantonCablaByIdRefresh) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_CABLE_FEATURE_PON_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак PON изменен!', 'snackbarWarning');
              cantonCablaByIdRefresh(lineId);
             // handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Optic KTV
export const UpdateLineKtvComponents = async (lineId, status, showSnackbar, handleClickSummit, user, cantonCablaByIdRefresh) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_CABLE_FEATURE_KTV_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак KTV изменен!', 'snackbarWarning');
              cantonCablaByIdRefresh(lineId);
              //handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Optic Ethernet
export const UpdateLineEtherComponents = async (lineId, status, showSnackbar, handleClickSummit, user, cantonCablaByIdRefresh) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_CABLE_FEATURE_ETHER_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак Ethernet изменен!', 'snackbarWarning');
              //handleClickSummit();
              cantonCablaByIdRefresh(lineId);
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
} 

// Обновление Fob PON
export const UpdateFobPonComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_FOB_FEATURE_PON_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак PON изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Fob с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Optic KTV
export const UpdateFobKtvComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_FOB_FEATURE_KTV_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак KTV изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление FOB Ethernet
export const UpdateFobEtherComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_FOB_FEATURE_ETHER_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак Ethernet изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Оптика с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
} 


// Обновление Coupling PON
export const UpdateCouplingPonComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_COUPLING_FEATURE_PON_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак PON изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Муфта с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Coupling KTV
export const UpdateCouplingKtvComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_COUPLING_FEATURE_KTV_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак KTV изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Муфта с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Coupling Ethernet
export const UpdateCouplingEtherComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_COUPLING_FEATURE_ETHER_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак Ethernet изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Муфта с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
} 

// Обновление PonBox PON
export const UpdatePonBoxPonComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_PONBOX_FEATURE_PON_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак PON изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Понбокс с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление PonBox KTV
export const UpdatePonBoxKtvComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_PONBOX_FEATURE_KTV_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак KTV изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Понбокс с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление PonBox Ethernet
export const UpdatePonBoxEtherComponents = async (lineId, status, showSnackbar, handleClickSummit, user) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_PONBOX_FEATURE_ETHER_API_URL}${lineId}`,{ feature: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак Ethernet изменен!', 'snackbarWarning');
              handleClickSummit();
          } else if (response.status === 404) {
              showSnackbar('Понбокс с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
} 

// Обновление Divider PON
export const UpdateDividerPonComponents = async (dividerId, status, showSnackbar) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_DIVIDER_FEATURE_PON_API_URL}${dividerId}`,{ feature: status }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак PON изменен!', 'snackbarWarning');
          } else if (response.status === 404) {
              showSnackbar('Делитель с указанным ID не найдена !', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

// Обновление Divider KTV
export const UpdateDividerKtvComponents = async (dividerId, status, showSnackbar) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_DIVIDER_FEATURE_KTV_API_URL}${dividerId}`,{ feature: status }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Признак KTV изменен!', 'snackbarWarning');
          } else if (response.status === 404) {
              showSnackbar('Делитель с указанным ID не найдена !', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}


// Обновление статуса CABLE (отображение / скрытие)
export const UpdateStatusCable = async (selectedComponent, inputId, showSnackbar, user, handleSearchClick) => {
  const token = localStorage.getItem('token');
  if(selectedComponent === '' || inputId === '') {
    showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
  }  
  else if (!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

    if (selectedComponent === CABLE) {
      try {
        const response = await axios.patch(`${UPDATE_CABLE_STATUS_API_URL}${inputId}?authorId=${user}`, null, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Кабель удалена!', 'snackbarWarning');
              handleSearchClick();
          } else if (response.status === 404) {
              showSnackbar('Кабель с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
    }     
    else {
      showSnackbar('Какая-то очень страшная ошибка!', 'snackbarWarning');
    }
  }
}

  // Обновление Усилителя (ВКЛ \ ВЫКЛ)
export const UpdateAmplifierActivity = async (id, status, showSnackbar, user, refresh) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${UPDATE_AMPLIFIER_STATUS_ACTIVITY_API_URL}${id}`,{ activity: status, authorId: user }, {
          headers: {

              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Статус изменен!', 'snackbarWarning');
              refresh();
              
          } else if (response.status === 404) {
              showSnackbar('Усилитель с указанным ID не найдена или пользователь не совпадает!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}
